export default __webpack_public_path__ + "assets/images/button-almost-good.cdec1a3f36d40101b3acec9d603c22eb.svg";